import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  stkRcptSync01ResetTimestamp: ['currentPage', 'sorts', 'filters', 'pageSize'],
  stkRcptSync01GoToDocument: ['hdrId'],
  stkRcptSync01FetchStkRcptSync01: ['currentPage', 'sorts', 'filters', 'pageSize'],
  stkRcptSync01FetchStkRcptSync01Loading: ['boolean'],
  stkRcptSync01FetchStkRcptSync01Success: [
    'documents',
    'currentPage',
    'lastPage',
    'total',
    'pageSize'
  ],
  stkRcptSync01AddSelectedDocuments: ['selectedDocuments'],
  stkRcptSync01RemoveSelectedDocuments: ['selectedDocuments'],
  stkRcptSync01SetWorkspaceVisible: ['boolean'],

  stkRcptSync01SyncNow: ['hdrIds'],
  stkRcptSync01SyncNowSuccess: null,
  stkRcptSync01SyncLoading: ['boolean']
});

export const StkRcptSync01Types = Types;
export default Creators;
